import urls from '../constants/urls';

import { gatherErrors } from '../utils/errorHandling';
import {
  CHECKING_UNIQUENESS,
  CHECKING_UNIQUENESS_FAILED,
  UNIQUENESS,
} from './exclusionList';

export const UPDATE_EXCLUSION_NUMBER_FAILED =
  'exclusionNumber/UPDATE_EXCLUSION_NUMBER_FAILED';
export const UPDATE_EXCLUSION_NUMBER_SUCCESS =
  'exclusionNumber/UPDATE_EXCLUSION_NUMBER_SUCCESS';
export const UPDATING_EXCLUSION_NUMBER =
  'exclusionNumber/UPDATING_EXCLUSION_NUMBER';

export const LOADING_EXCLUSION_NUMBER =
  'exclusionNumber/LOADING_EXCLUSION_NUMBER';
export const EXCLUSION_NUMBER_LOAD_FAILED =
  'exclusionNumber/EXCLUSION_NUMBER_LOAD_FAILED';
export const EXCLUSION_NUMBER_LOAD_SUCCESS =
  'exclusionNumber/EXCLUSION_NUMBER_LOAD_SUCCESS';

const initialState = {
  exclusionNumber: null,

  updateErrors: {},

  failedLoading: false,

  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_EXCLUSION_NUMBER:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case EXCLUSION_NUMBER_LOAD_SUCCESS:
      return {
        ...state,
        exclusionNumber: action.payload.data.data,
        isLoading: false,
      };

    case EXCLUSION_NUMBER_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    case UPDATING_EXCLUSION_NUMBER:
      return {
        ...state,
        updateErrors: {},
        isSaving: true,
        failedSaving: false,
      };

    case UPDATE_EXCLUSION_NUMBER_SUCCESS:
      return {
        ...state,
        updateErrors: {},
        isSaving: false,
      };

    case UPDATE_EXCLUSION_NUMBER_FAILED:
      return {
        ...state,
        updateErrors: gatherErrors(
          action.error,
          'update_exclusion_number_failed'
        ),
        isSaving: false,
        failedSaving: true,
      };

    default:
      return state;
  }
};

export const loadExclusionNumber = (hospitalId, numberId) => dispatch => {
  return dispatch({
    types: [
      LOADING_EXCLUSION_NUMBER,
      EXCLUSION_NUMBER_LOAD_SUCCESS,
      EXCLUSION_NUMBER_LOAD_FAILED,
    ],
    payload: {
      request: {
        url: urls.hospitals.exclusionList.show(hospitalId, numberId),
      },
    },
  });
};

export const updateExclusionNumber = (
  hospitalId,
  numberId,
  params
) => dispatch => {
  const numberParams = {
    name: params.name,
    number: params.number,
  };

  return dispatch({
    types: [
      UPDATING_EXCLUSION_NUMBER,
      UPDATE_EXCLUSION_NUMBER_SUCCESS,
      UPDATE_EXCLUSION_NUMBER_FAILED,
    ],
    payload: {
      request: {
        method: 'patch',
        url: urls.hospitals.exclusionList.update(hospitalId, numberId),
        data: { exclusion_list: numberParams },
      },
    },
  });
};

export const checkUniqueness = (hospitalId, numberId, params) => dispatch => {
  const numberParams = {
    name: params.name,
    number: params.number,
  };

  return dispatch({
    types: [CHECKING_UNIQUENESS, UNIQUENESS, CHECKING_UNIQUENESS_FAILED],
    payload: {
      request: {
        method: 'get',
        url: urls.hospitals.exclusionList.edit(hospitalId, numberId),
        params: numberParams,
      },
    },
  });
};
